import { ReactNode } from "react"
import { classNames } from "../../utils/helpers"
import Box from "../Box"

interface SectionColumnProps {
  children: ReactNode
  className?: string
}
const SectionColumn = (props: SectionColumnProps) => {
  const { children, className, ...others } = props

  return (
    <Box
      className={classNames(
        "flex w-full flex-col items-center lg:flex-row lg:items-start gap-6",
        className
      )}
      {...others}
    >
      {children}
    </Box>
  )
}

export default SectionColumn
